import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  ApplicationTypes,  
  AbnComponentValue,
  AcnComponentValue,
  AzureStorageDocument,
  UploadedDocumentRef,
  BrokerageSelectionType,
  BusinessLoansApplication,
  BusinessNumberSearchValue,
  BusinessSearchResultValue,
  DocumentTag,
  EntityTypePartnershipOption,
  GetSalesforceContactSameAccountFunc,
  GetUserSameCompanyFunc,
  LoanTermType,
  LoanTermsSelectionWithInputValue,
  NotNullable,
  PaymentFrequencyType,
  PaymentFrequencyValueOptions,
  PlacesDetailsFn,
  PlacesSearchResultFn,
  SalesforceContactSameAccountSelectionValue,
  SaveApplicationPricingDetailsData,
  SelectContactValue,
  SliderComponentValue,
  UploadAzureFiles,
  RequiredTrustDeed,
  UploadAzureFilesValue,
  UserSameCompanySelectionValue,
  UserSelectionValue,
  YesNoValue,
  booleanToYesNo,
  calculateBusinessLoanEstimation,
  constants,
  filesToBase64Files,
  getFileTags,
  isAddressEquals,
  isApplicationApplicantIndividual,
  isApplicationApplicantsSoleTrader,
  isExternalUser,
  maxLoanForBusinessLoan,
  patchAcn,
  toDraftSimplifiedApplication,
  SubdivisionIndustrySelectionValue,
  GetIndustryDivisionsFn,
  GetIndustryGroupsByDivisionCodeFn,
  GetIndustryClassesByGroupCodeFn,
  KybRefreshFn,
  KybResultFn,
  KybSetManualModeFn,
  KybInitiateCorporatePartyFn,
  KybResult,
  kybHasOwnKeyPeople,
  KybKeyPeopleValue,
  KYB_KEY_PEOPLE_STEP_VALIDATION_MESSAGE,
  IndividualDetailsListValue,
  BORROWING_ENTITY_LOCKED_HINT,
  ApplicationCommercialEntityWrite,
  BUSINESS_LOAN_MAX_BROKERAGE_PERCENT,
} from '@portal-workspace/grow-shared-library';
import {
  AnnualRevenueValue, BusinessNumberSearchFn,
  SalesforceContactSameAccountSelectionComponent,
  UserSameCompanySelectionComponent,
  applicantsThatAreGuarantor,
  applicationToAbn,
  applicationToAcn,
  applicationToAdditionalBrokerCorrespondent,
  applicationToAdverseOnFile,
  applicationToApplicants,
  applicationToApplicationNotes,
  applicationToBrokerContact,
  applicationToBrokerFlowDocumentId,
  applicationToBrokerSearchValue,
  applicationToBrokerage,
  applicationToBusinessSearchValue,
  applicationToEquifaxDirectorScoreMeetsThreshold,
  applicationToGstAgeMonths,
  applicationToGstAgeMonthsWithContinuity,
  searchResultToGstAgeMonths,
  searchResultToGstAgeMonthsWithContinuity,
  applicationToDocFeeFinanced,
  applicationToGuarantors,
  applicationToHasAdditionalBrokerCorrespondent,
  applicationToIndustrySector,
  applicationToSubdivisionIndustrySector,
  applicationToLegalName,
  applicationToLoanAmount,
  applicationToLoanPurpose,
  applicationToLoanTermsValue,
  applicationToOrganisationType,
  applicationToPaymentFrequency,
  applicationToPreviousBusiness,
  applicationToPrimaryAddress,
  applicationToRegisteredBusinessAddress,
  applicationToPrimaryIndustry,
  applicationToPropertyOwner,
  applicationToReferences,
  applicationToRevenue,
  duplicateFileNameValidator,
  formControlErrorKeys,
  formControlErrorMessage,
  fromApplicantToInteflowCommercialEntities,
  fromApplicantToInteflowIndividualsData,
  fromContactToInteflowContacts,
  fromGuarantorToInteflowCommercialEnttities,
  fromGuarantorToInteflowIndividuals,
  fromReferenceToInteflowReferences,
  getUser,
  individualGarantors,
  collectIndividualIdDocumentUploads,
  tagIndividualIdDocumentFiles,
  noSpaceValidator,
  setStepper2StepConfig,
  setupUntilDestroy,
  toApiAddress,
  toInteflowEntityTypes,
  toInteflowLegalName,
} from '@portal-workspace/grow-ui-library';

import { UntilDestroy } from '@ngneat/until-destroy';
import { AggregatorSearchComponentValue, BusinessSearchValue } from '@portal-workspace/grow-shared-library';
import { AggregatorSearchFn, ApplicationDialogService, BusinessSearchFn, PortalHotToastService, calculateAbnAgeOverrideFromPreviousBusiness, previousBusinessNotPrimaryValidator } from '@portal-workspace/grow-ui-library';
import { catchError, from, lastValueFrom, of, Observable, Subscription } from 'rxjs';
import { RedbookService } from '../../service/redbook.service';

import { CdkStepper, CdkStepperModule } from '@angular/cdk/stepper';
import { Location, NgTemplateOutlet } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute, Params, Router } from '@angular/router';
import {
  Address2ComponentValue,
  AppCalculator, ApplicationApplicant, Base64File, BrokerOfUser, BrokerageSelectionValue, BusinessFinanceSummary,
  DirectorValue, EntityTypeTrustOption, EntityTypeValue, EntityTypes, GeoLocation, GuarantorValue,
  GuarantorKybSelectionsEvent,
  IndividualGuarantor, LoanPurposeValue, MIN_LOAN_AMOUNT_BUSINESS_LOAN_AND_OVERDRAFT, MemberValue, OriginatorBusiness, PartnerValue, PaymentFrequencyValue, PrimaryIndustrySelectionValue, PROPERTY_SECURITY_ACKNOWLEDGEMENT_THRESHOLD, RatecardDetails, ReferenceValue, SecondaryIndustrySelectionValue, SoleTraderValue, TermRate, TotalPaymentBreakupDialogData, TrusteeValue, UpdateApplicationData,
  WizardSubmitData, UploadFileValue, User, defaultDocuments
} from '@portal-workspace/grow-shared-library';
import { AbnComponent, AcnComponent, AggregatorSearchComponent, AnnualRevenueComponent, ApplicationHeaderSegmentComponent, ApplicationStepper2Component, BrokerageSelectionComponent, BusinessFinanceSummaryComponent, BusinessLoanTermsSelectionComponent, BusinessNumberSearchComponent, BusinessSearchComponent, CurrencyInputComponent, CustomAddressComponent, DirectorComponent, EntityTypeComponent, GuarantorComponent, GuarantorComponentEvent, LoanPurposeSelectionComponent, LoanTermsSelectionWithInputComponent, MarkDirective, MemberComponent, MessageBoxComponent, MobileComponent, PartnerComponent, PaymentFrequencySelectionComponent, PrimaryIndustrySelectionComponent, ReferenceComponent, SecondaryIndustrySelectionComponent, SoleTraderComponent, TrustDeedUploadComponent, TrusteeComponent, UploadFileComponent, UploadFilesMultiTagsComponent, UploadedFilesListComponent, UploadedFilesListComponentEvent, UserSelectionComponent, YesNoComponent, mergeGuarantorKybSelections, requiredAllowEmptyValidator } from '@portal-workspace/grow-ui-library';
import _ from 'lodash';
import moment, { Moment } from 'moment';
import numeral from 'numeral';
import { filter, map, switchMap, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AdminService } from '../../service/admin.service';
import {
  ApplicationService,
} from '../../service/application.service';
import { AuthService } from '../../service/auth.service';
import { LocalApplicationsDbService } from "../../service/local-applications-db.service";
import {
  navigationUrlForApplicationsWithQueryParams,
  navigationUrlForBusinessFinanceWithQueryParams,
  navigationUrlForNewApplication
} from '../../service/navigation-urls';
import { SubdivisionIndustrySelectionComponent } from '@portal-workspace/grow-ui-library';
import { KybKeyPeopleComponent, KybStatusComponent } from '@portal-workspace/grow-ui-library';
import {
  consentAcknowledgementIndividuals,
  IndividualDetailsListComponent,
  mergeSavedIndividualsIntoInteflowIndividuals,
  savedIndividualsToPrimaryContact,
  savedIndividualsToContacts,
} from '@portal-workspace/grow-ui-library';
import { DigitalIdService } from '../../service/digital-id.service';
import { IndustryService } from '../../service/industry.service';

// NOTE: Page to land when you are in DRAFT (new unsubmitted) business finance application
@UntilDestroy({arrayName: 'subscriptions'})
@Component({
    templateUrl: './business-finance.page.html',
    styleUrls: ['./business-finance.page.scss'],
    standalone: true,
    imports: [
      ApplicationStepper2Component,
      CdkStepperModule,
      NgTemplateOutlet,
      FormsModule,
      ReactiveFormsModule,
      BusinessSearchComponent,
      MarkDirective,
      MatCheckboxModule,
      MatTooltipModule,
      UserSelectionComponent,
      AggregatorSearchComponent,
      LoanPurposeSelectionComponent,
      BusinessLoanTermsSelectionComponent,
      BrokerageSelectionComponent,
      PaymentFrequencySelectionComponent,
      YesNoComponent,
      CurrencyInputComponent,
      EntityTypeComponent,
      AbnComponent,
      AcnComponent,
      AnnualRevenueComponent,
      PrimaryIndustrySelectionComponent,
      SecondaryIndustrySelectionComponent,
      CustomAddressComponent,
      MobileComponent,
      ApplicationHeaderSegmentComponent,
      TrusteeComponent,
      SoleTraderComponent,
      PartnerComponent,
      DirectorComponent,
      MemberComponent,
      KybKeyPeopleComponent,
      KybStatusComponent,
      IndividualDetailsListComponent,
      GuarantorComponent,
      MatFormFieldModule,
      MatInputModule,
      ReferenceComponent,
      MessageBoxComponent,
      TrustDeedUploadComponent,
      UploadedFilesListComponent,
      UploadFileComponent,
      UploadFilesMultiTagsComponent,
      BusinessFinanceSummaryComponent,
      BusinessNumberSearchComponent,
      UserSameCompanySelectionComponent,
      SalesforceContactSameAccountSelectionComponent,
      LoanTermsSelectionWithInputComponent,
      SubdivisionIndustrySelectionComponent,
    ],
})
export class BusinessFinancePage implements OnInit {

  BUSINESS_LOAN_MAX_BROKERAGE_PERCENT = BUSINESS_LOAN_MAX_BROKERAGE_PERCENT;

  @HostListener( 'window: popstate', ['$event'])
  async onPopState(event: Event): Promise<void> {
    event.preventDefault();
    await this.router.navigateByUrl(navigationUrlForApplicationsWithQueryParams(this.router, this.queryParams));
  }
  
  @ViewChild('uploadFilesMultiTagsComponent') uploadFilesMultiTagsComponent!: UploadFilesMultiTagsComponent;
  @ViewChild(LoanPurposeSelectionComponent) loanPurposeComponent!: LoanPurposeSelectionComponent;

  businessSearchPlaceholder:string="Enter name or ABN…"

  getIndustryDivisionsFn!: GetIndustryDivisionsFn;
  getIndustryGroupsByDivisionCodeFn!: GetIndustryGroupsByDivisionCodeFn;
  getIndustryClassesByGroupCodeFn!: GetIndustryClassesByGroupCodeFn;
  placesSearchResultFn!: PlacesSearchResultFn;
  placesDetailsFn!: PlacesDetailsFn;
  subscriptions: Subscription[] = [];
  existingApplication: BusinessLoansApplication | null = null; // will exists if there is a draft
  existingApplicationBureauReport: BusinessLoansApplication['CompanyDetails'] | null = null;
  rateCard: RatecardDetails | null = null;
  // global:
  ip: string = '';
  geoLocation: GeoLocation = {};
  user: User = getUser()!;
  isExternalUser : boolean = isExternalUser(this.user);
  otherUsersObservable?: Observable<NotNullable<UserSelectionValue>[]>;
  brokerOfUser: BrokerOfUser | null = null;
  acceptedQuotation = false;
  brokerApplicationId: string | null = null;
  applicationId: number | null = null;

  // ADO-1295: the borrowing entity (and previous business) lock once the broker moves off the
  // application step, so the company check and key-people selections stay anchored to the chosen
  // entity. An application id exists only after that step has been saved, which also covers a
  // reopened draft.
  get borrowingEntityLocked(): boolean {
    return !!this.applicationId;
  }

  get step1BusinessLockedHint(): string | null {
    return this.borrowingEntityLocked ? BORROWING_ENTITY_LOCKED_HINT : null;
  }

  // global: step 3 onwards
  organisationName: string = 'Not available';
  terms: TermRate | null = null;          // available after chart popups
  calculator: AppCalculator | null = null;   // available after chart popups

  // after popup confirmation
  businessUseOnly = false;
  selfServiceability = false;

  queryParams: Params = {};

  errorKeys = formControlErrorKeys;
  errorMessages = formControlErrorMessage;

  defaultDocuments = defaultDocuments;

  getFileTags = getFileTags;

  // STEP 1:
  step1BusinessSearchFn!: BusinessSearchFn;
  step1GetUserSameCompanyFn!: GetUserSameCompanyFunc;
  step1GetSalesforceContactSameAccountFn!: GetSalesforceContactSameAccountFunc;
  step1BrokerSearchFn!: AggregatorSearchFn;
  step1OrgSalesforceId: string | null = null;
  step1NoOtherUsersInCompany = true;
  formControlStep1Broker!: FormControl<AggregatorSearchComponentValue>;
  formGroupStep1!: FormGroup<{
    broker: FormControl<AggregatorSearchComponentValue>,
    business: FormControl<BusinessSearchValue>,
    showCorrespondent: FormControl<boolean | null>,
    correspondent: FormControl<UserSameCompanySelectionValue>,
    previousBusiness: FormControl<BusinessNumberSearchValue>,
    brokerContact:FormControl<SalesforceContactSameAccountSelectionValue>
  }>;
  formControlStep1Business!: FormControl<BusinessSearchValue>;
  formControlStep1ShowCorrespondent!: FormControl<boolean | null>;
  formControlStep1Correspondent!: FormControl<UserSameCompanySelectionValue>;
  formControlStep1BrokerContact!: FormControl<SalesforceContactSameAccountSelectionValue>;
  formControlStep1PreviousBusiness!: FormControl<BusinessNumberSearchValue>;

  /** GST age that treats a cancelled registration as 0, unlike result.GSTAgeMonths. */
  get step1GstAgeMonths(): number {
    const v = this.formControlStep1Business?.value;
    if (!v || v.type !== 'search-result') return 0;
    return searchResultToGstAgeMonths(v.result, 0);
  }

  step2Repayment: string = '';
  step2MaxLimit: number = 500000;
  step2MinLimit: number = MIN_LOAN_AMOUNT_BUSINESS_LOAN_AND_OVERDRAFT;
  step2EstimatedDrawdownDate: Moment = moment();
  formControlStep2LoanPurpose!: FormControl<LoanPurposeValue | null>;
  formControlStep2LoanAmount!: FormControl<SliderComponentValue>;
  formControlStep2LoanTerms!: FormControl<LoanTermsSelectionWithInputValue>;
  formControlStep2Brokerage!: FormControl<BrokerageSelectionValue>;
  formControlStep2PaymentFrequency!: FormControl<PaymentFrequencyValue>;
  formControlStep2PropertyOwner!: FormControl<YesNoValue>;
  formControlStep2AdverseOnFile!: FormControl<YesNoValue>;
  formControlStep2EquifaxDirectorScoreAbove700!: FormControl<YesNoValue>;
  formControlStep2DocFeeFinanced!: FormControl<YesNoValue>;
  formGroupStep2!: FormGroup<{
    loanPurpose: FormControl<LoanPurposeValue | null>,
    // broker: FormControl<AggregatorSearchComponentValue>,
    loanTerms: FormControl<LoanTermsSelectionWithInputValue>,
    loanAmount: FormControl<SliderComponentValue>,
    brokerage: FormControl<BrokerageSelectionValue>,
    paymentFrequency: FormControl<PaymentFrequencyValue>,
    propertyOwner: FormControl<YesNoValue>,
    adverseOnFile: FormControl<YesNoValue>,
    equifaxScore: FormControl<YesNoValue>,
    docFeeFinanced: FormControl<YesNoValue>,
  }>;

  // STEP 3:
  formControlStep3OrganisationType!: FormControl<EntityTypeValue>;
  formControlStep3Abn!: FormControl<AbnComponentValue>;
  formControlStep3Acn!: FormControl<AcnComponentValue>;
  formControlStep3AnnualRevenue!: FormControl<AnnualRevenueValue>;
  formControlStep3PrimaryIndustry!: FormControl<PrimaryIndustrySelectionValue>;
  formControlStep3IndustrySector!: FormControl<SecondaryIndustrySelectionValue>;
  formControlStep3SubdivisionIndustrySector!: FormControl<SubdivisionIndustrySelectionValue>;
  formControlStep3PrimaryBusinessAddress!: FormControl<Address2ComponentValue>;
  formControlStep3RegisteredBusinessAddress!: FormControl<Address2ComponentValue>;
  // The company check the step waits on. Held so step 4 can render its key people without a second
  // read, and so a re-entered step shows the form immediately instead of waiting again.
  step3KybResult: KybResult | null = null;
  step3ManualKyb = false;
  // The stepper builds every step's content up front, so the company check must not begin waiting
  // until this step is actually reached.
  step3Active = false;
  step3KybResultFn!: KybResultFn;
  step3KybRefreshFn!: KybRefreshFn;
  kybSetManualModeFn!: KybSetManualModeFn;

  /**
   * Whether the form is still behind the applicant's company check.
   *
   * A trust or partnership is let straight through: its key people are the trustees/partners typed
   * in on step 4, so this step reads nothing from that run. Those brokers enter both addresses by
   * hand, because the registry prefill arrives with the same result.
   */
  get step3AwaitingKyb(): boolean {
    return !this.step3ManualKyb
      && !this.step3KybResult
      && kybHasOwnKeyPeople(this.step3OnwardsOrganisationType);
  }

  formGroupStep3!: FormGroup<{
    organisationType: FormControl<EntityTypeValue>,
    abn: FormControl<AbnComponentValue>,
    acn: FormControl<AcnComponentValue>,
    annualRevenue: FormControl<AnnualRevenueValue>,
    primaryIndustry: FormControl<PrimaryIndustrySelectionValue>,
    industrySector: FormControl<SecondaryIndustrySelectionValue>,
    subdivisionIndustrySector: FormControl<SubdivisionIndustrySelectionValue>,
    primaryBusinessAddress: FormControl<Address2ComponentValue>,
    registeredBusinessAddress: FormControl<Address2ComponentValue>,
  }>;

  step3PrimaryIndustryDivisionCode: string | null = null;
  step3IndustrySectorGroupCode: string | null = null;

  // STEP 4:
  step4BusinessSearchFn!: BusinessSearchFn;
  step4BusinessNumberSearchFn!: BusinessNumberSearchFn;
  step4KybResultFn!: KybResultFn;
  step4KybInitiateCorporatePartyFn!: KybInitiateCorporatePartyFn;
  step4KybWarnings: string[] = [];
  // As step3Active: the step is built up front, so its waiting panel must not start before it is
  // reached.
  step4Active = false;
  step3OnwardsOrganisationType: EntityTypes | null = null;
  formControlStep4Applicant!: FormControl<ApplicationApplicant>;
  formControlStep4KybKeyPeople!: FormControl<KybKeyPeopleValue | null>;
  formGroupStep4!: FormGroup<{
    applicant: FormControl<ApplicationApplicant>,
    kybKeyPeople: FormControl<KybKeyPeopleValue | null>,
  }>;

  // STEP 5:
  step5CompanySearchFn!: BusinessSearchFn;
  step5BusinessNumberSearchFn!: BusinessNumberSearchFn;
  // Ticks made against an additional guarantor entity's key people. Merged into the Key People
  // payload on save, which is a full sync and would otherwise deselect them.
  step5KybSelections: GuarantorKybSelectionsEvent | null = null;
  step5KybWarnings: string[] = [];
  formControlStep5Guarantors!: FormControl<GuarantorValue>;
  formGroupStep5!: FormGroup<{
    guarantors: FormControl<GuarantorValue>,
  }>;

  // STEP 6: individual details review (also where the primary contact is chosen)
  formControlStep6IndividualDetails!: FormControl<IndividualDetailsListValue>;
  formGroupStep6!: FormGroup<{
    individualDetails: FormControl<IndividualDetailsListValue>,
  }>;
  @ViewChild('individualDetailsListComponent') individualDetailsListComponent?: IndividualDetailsListComponent;
  @ViewChild(KybKeyPeopleComponent) kybKeyPeopleComponent?: KybKeyPeopleComponent;
  @ViewChild(GuarantorComponent) guarantorComponent?: GuarantorComponent;

  // STEP 7:
  formControlStep7BrokerflowDocumentId!: FormControl<string | null>;
  formControlStep7References!: FormControl<ReferenceValue>;
  formGroupStep7!: FormGroup<{
    brokerflowDocumentId: FormControl<string | null>,
    references: FormControl<ReferenceValue>,
  }>;

  step9UploadedDocs: AzureStorageDocument[] = [];
  applicationDocuments: AzureStorageDocument[] | null = null;
  step4DeletedIdDocuments: UploadedDocumentRef[] = [];
  step5DeletedIdDocuments: UploadedDocumentRef[] = [];
  step9DeletedUploadedDocs: Exclude<AzureStorageDocument[], null> = [];
  filesUploadedToAzure: Base64File[] = [];

  // step 8: trust deeds. Derived here rather than inside the step so the stepper can leave the step
  // out entirely when the application needs no deed.
  requiredTrustDeeds: RequiredTrustDeed[] = [];
  step8DeletedUploadedDocs: Exclude<AzureStorageDocument[], null> = [];
  formControlStep8TrustDeeds!: FormControl<UploadAzureFilesValue>;
  formGroupStep8!: FormGroup<{
    trustDeeds: FormControl<UploadAzureFilesValue>,
  }>;

  // STEP 9:
  formControlStep9OtherSupportingDocuments!: FormControl<UploadAzureFilesValue>;
  formGroupStep9!: FormGroup<{
    otherSupportingDocuments: FormControl<UploadAzureFilesValue>,
  }>;

  // STEP 10:
  formControlStep10ApplicationNotes!: FormControl<string | null>;
  formGroupStep10!: FormGroup<{
    applicationNotes: FormControl<string | null>,
  }>;

  // STEP 11:
  step11Summary!: BusinessFinanceSummary;
  formGroupStep11!: FormGroup<{}>;

  showAddressFormFlag:boolean=true
  documentTypes: DocumentTag[] = [];

  applicationType: ApplicationTypes = 'BusinessLoans'; // Set default or get from data/queryParams
  
  constructor(private formBuilder: FormBuilder,
              private redbookService: RedbookService,
              private route: ActivatedRoute,
              private toastService: PortalHotToastService,
              private applicationDialogService: ApplicationDialogService,
              private localApplicationDbService: LocalApplicationsDbService,
              private adminService: AdminService,
              private router: Router,
              private location: Location,
              private applicationService: ApplicationService,
              private authService: AuthService,
              private digitalIdService: DigitalIdService,
              private industryService: IndustryService) {
    this.placesSearchResultFn = this.authService.getGooglePlacesSearchResultFn;
    this.placesDetailsFn = this.authService.getGooglePlacesDetailsFn;
    this.getIndustryDivisionsFn = this.industryService.getIndustryDivisionsFn;
    this.getIndustryGroupsByDivisionCodeFn = this.industryService.getIndustryGroupsByDivisionCodeFn;
    this.getIndustryClassesByGroupCodeFn = this.industryService.getIndustryClassesByGroupCodeFn;
  }

  async ngOnInit() {
    setupUntilDestroy(this);
    this.queryParams = this.route.snapshot.queryParams ?? {};
    this.existingApplication = (this.route.snapshot.data as any).application;
    this.rateCard = (this.route.snapshot.data as any).ratecard;
    console.log('Resolved [BusinessLoan] application', this.existingApplication);
    if (this.existingApplication) {
      if (this.existingApplication.ApplicationType != 'BusinessLoans') {
        this.toastService.error(`This application ${this.existingApplication.ApplicationId} is not an Business Term Loan application`, `Invalid application type`);
      }
    }

    this.initStep1();
    this.initStep2();
    this.initStep3();
    this.initStep4();
    this.initStep5();
    this.initStep6();
    this.initStep7();
    this.initStep8();
    this.initStep9();
    this.initStep10();
    this.initStep11();

    this.populate();
    this.step2UpdateMaxLimit();

    // get ip
    const sub1 = this.applicationService.getIpAddress().pipe(
      map(r => {
        if (r.status) {
          this.ip = r.payload;
          console.log('**** ip', this.ip);
        }
      })
    ).subscribe();
    this.subscriptions.push(sub1);

    // get geolocation
    try {
      const geoLocation = await this.applicationService.getGeoLocation();
      if (geoLocation) {
        this.geoLocation = geoLocation;
      }
      console.log('**** geolocation', geoLocation);
    } catch(err) {
      alert(err);
    }


    // get broker of user
    const sub2 = this.applicationService.getBrokerOfUser(this.user.UserId).pipe(
      tap(r => {
        if (r.status) {
          this.brokerOfUser = r.payload;
        }
      })
    ).subscribe();
    this.subscriptions.push(sub2);
  }

  populate() {
    if (this.existingApplication) {
      // 1
      const businessSearchValue = applicationToBusinessSearchValue(this.existingApplication);
      const previousBusinessValue = applicationToPreviousBusiness(this.existingApplication);

      this.formControlStep1PreviousBusiness.setValue(previousBusinessValue);
      this.formControlStep1Business.setValue(businessSearchValue);
      this.formControlStep1ShowCorrespondent.setValue(applicationToHasAdditionalBrokerCorrespondent(this.existingApplication));
      this.formControlStep1Correspondent.setValue(applicationToAdditionalBrokerCorrespondent(this.existingApplication));
      this.brokerApplicationId = this.existingApplication.BrokerAppId;
      this.applicationId = this.existingApplication.ApplicationId;
      this.acceptedQuotation = this.existingApplication.AcceptQuotation;
      this.organisationName = applicationToLegalName(this.existingApplication) ?? '';
      const brokerSearchValue = applicationToBrokerSearchValue(this.existingApplication);
      this.formControlStep1Broker.setValue(brokerSearchValue);
      this.step1OrgSalesforceId = brokerSearchValue?.salesforceId ?? null;
      this.formControlStep1BrokerContact.setValue(applicationToBrokerContact(this.existingApplication));

      // 2
      this.acceptedQuotation = this.existingApplication.AcceptQuotation;
      this.existingApplicationBureauReport = this.existingApplication.CompanyDetails;
      this.formControlStep2LoanPurpose.setValue(applicationToLoanPurpose(this.existingApplication) ?? null);
      this.formControlStep2LoanAmount.setValue(applicationToLoanAmount(this.existingApplication));
      this.formControlStep2LoanTerms.setValue(applicationToLoanTermsValue(this.existingApplication));
      this.formControlStep2Brokerage.setValue(applicationToBrokerage(this.existingApplication));
      this.formControlStep2PaymentFrequency.setValue(applicationToPaymentFrequency(this.existingApplication) ??
      PaymentFrequencyValueOptions.find(o => o.type === 'Monthly') ?? null);
      this.formControlStep2PropertyOwner.setValue(applicationToPropertyOwner(this.existingApplication));
      this.formControlStep2AdverseOnFile.setValue(applicationToAdverseOnFile(this.existingApplication));
      this.formControlStep2EquifaxDirectorScoreAbove700.setValue(applicationToEquifaxDirectorScoreMeetsThreshold(this.existingApplication, '>=700'));
      this.formControlStep2DocFeeFinanced.setValue(applicationToDocFeeFinanced(this.existingApplication));

      // 3
      this.formControlStep3OrganisationType.setValue(applicationToOrganisationType(this.existingApplication));
      this.formControlStep3Abn.setValue(applicationToAbn(this.existingApplication));
      this.formControlStep3Acn.setValue(applicationToAcn(this.existingApplication));
      this.formControlStep3AnnualRevenue.setValue(applicationToRevenue(this.existingApplication));

      const primaryIndustry = applicationToPrimaryIndustry(this.existingApplication);
      this.formControlStep3PrimaryIndustry.setValue(primaryIndustry);
      this.step3PrimaryIndustryDivisionCode = primaryIndustry?.code ?? null;
      const industrySector = applicationToIndustrySector(this.existingApplication);
      this.step3IndustrySectorGroupCode = industrySector?.code ?? null;
      this.formControlStep3IndustrySector.setValue(industrySector);
      this.formControlStep3SubdivisionIndustrySector.setValue(applicationToSubdivisionIndustrySector(this.existingApplication));
      this.formControlStep3PrimaryBusinessAddress.setValue(applicationToPrimaryAddress(this.existingApplication));
      this.formControlStep3RegisteredBusinessAddress.setValue(applicationToRegisteredBusinessAddress(this.existingApplication));

      // 4
      const applicants = applicationToApplicants(this.existingApplication);
      this.formControlStep4Applicant.setValue(applicants);
      if (this.formControlStep4Applicant.value !== null) {
        let propertyOwner: any
        let residentialAddress: any
        if (isApplicationApplicantsSoleTrader(this.formControlStep4Applicant.value)) {
          propertyOwner = this.formControlStep4Applicant.value.propertyOwner;
          residentialAddress = this.formControlStep4Applicant.value.residentialAddress;
        }
        else {
          const applicant = this.formControlStep4Applicant.value;
          for (let i = 0; i <= applicant.length - 1; i++) {
            const currentApplicant = applicant[i];
            if (isApplicationApplicantIndividual(currentApplicant)) {
              propertyOwner = currentApplicant.propertyOwner;
              residentialAddress = currentApplicant.residentialAddress;
            }
          }
        }
        if (propertyOwner) {
          if (propertyOwner.propertyOwner) {
            if (isAddressEquals(residentialAddress, propertyOwner.address)) {
              this.showAddressFormFlag = false;
            }
          }
        }
      }

      // 5
      this.formControlStep5Guarantors.setValue(applicationToGuarantors(this.existingApplication));

      // 6 is the individual details step - it loads its own rows from ApplicationIndividual

      // 7
      this.formControlStep7BrokerflowDocumentId.setValue(applicationToBrokerFlowDocumentId(this.existingApplication));
      this.formControlStep7References.setValue(applicationToReferences(this.existingApplication));

      // 8-10
      this.formControlStep10ApplicationNotes.setValue(applicationToApplicationNotes(this.existingApplication));

      this.listUploadedDocuments();
      this.refreshRequiredTrustDeeds();

      this.documentTypes = this.existingApplication.DocumentTypes ?? [];

    } else {  // not prepopulating ie. creating new application

      // auto populate originator business if we have one
      const orignatorBusinessId = this.user?.OriginatorBusinessId;
      if (orignatorBusinessId) {
        this.subscriptions.push(this.applicationService.getOriginatorBusinessById(orignatorBusinessId).pipe(
          tap(r => {
            if (r.payload) {
              const originatorBusiness: OriginatorBusiness = r.payload;
              const v: AggregatorSearchComponentValue = {
                abn: originatorBusiness.ABN,
                entityName: originatorBusiness.EntityName,
                salesforceId: originatorBusiness.SalesforceId,
              }
              this.formControlStep1Broker.setValue(v);
            }
          })
        ).subscribe());

      }

      this.documentTypes = this.applicationDefaultDocuments(false);
    }
  }

  initStep1() {
    this.formControlStep1Business = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep1Broker = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep1PreviousBusiness =  this.formBuilder.control(null, [previousBusinessNotPrimaryValidator(() => this.formControlStep1Business.value)]);
    this.formControlStep1ShowCorrespondent = this.formBuilder.control(false)
    this.formControlStep1Correspondent = this.formBuilder.control(null);
    this.formControlStep1BrokerContact = this.formBuilder.control(null, [Validators.required]);
    this.formGroupStep1 = this.formBuilder.group({
      business: this.formControlStep1Business,
      broker: this.formControlStep1Broker,
      showCorrespondent: this.formControlStep1ShowCorrespondent,
      correspondent: this.formControlStep1Correspondent,
      brokerContact:this.formControlStep1BrokerContact,
      previousBusiness: this.formControlStep1PreviousBusiness,
    });
    this.step1BrokerSearchFn = (term)=> {
      return this.applicationService.searchBroker2(term).pipe(map(r => r.payload));
    }
    setStepper2StepConfig(this.formGroupStep1, {
      nextStepClickedFn: async (stepper) => {
        const currentBizValue = this.formControlStep1Business.value;
        const currentResult = currentBizValue?.type === 'search-result' ? currentBizValue.result : undefined;
        const gstAge = searchResultToGstAgeMonths(currentResult, 0);
        const gstThreshold = 12;
        if (currentBizValue?.type !== 'search-result' || gstAge >= gstThreshold) {
          await this.saveApplication(stepper, 1);
          return;
        }
        const gstAgeWithContinuity = searchResultToGstAgeMonthsWithContinuity(
          currentResult,
          this.formControlStep1PreviousBusiness.value,
          gstAge,
        );
        if (gstAgeWithContinuity < gstThreshold && !await this.confirmGstAgeException()) {
          return;
        }
        await this.saveApplication(stepper, 1);
      },
      previousStepClickedFn: async (stepper) => {
        if(this.applicationId){
          await this.router.navigateByUrl(navigationUrlForApplicationsWithQueryParams(this.router, this.queryParams));
        }else {
          await this.router.navigate(navigationUrlForNewApplication())
        }
      }
    });

    this.step1BusinessSearchFn = this.applicationService.businessSearchFn;
    this.step1GetUserSameCompanyFn = (orgSalesforceId: string) => {
      return this.authService.getOtherUsersInCompanyBySalesforceIdFn(orgSalesforceId).pipe(
        map(r => {
          // exclude this user
          const filteredCorrespndentUserList =  r.filter(u => u.UserId != this.user.UserId);
          this.step1NoOtherUsersInCompany = filteredCorrespndentUserList.length == 0;
          return filteredCorrespndentUserList;
        })
      );
    }
    this.step1GetSalesforceContactSameAccountFn = this.authService.getSalesforceContactSameAccountFn;
    this.subscriptions.push(this.formControlStep1Broker.valueChanges.pipe(
      tap(broker => {
        if (broker) {
          this.step1OrgSalesforceId = broker.salesforceId;
          this.step1GetUserSameCompanyFn(this.step1OrgSalesforceId).pipe().subscribe();
        }
      })
    ).subscribe());
    this.subscriptions.push(this.formControlStep1ShowCorrespondent.valueChanges.pipe(
      tap((r)=> {
        if(!r){
          this.formControlStep1Correspondent.setValue(null)
        }
      })
    ).subscribe())
    this.subscriptions.push(this.formControlStep1Business.valueChanges.pipe(
      tap((r: BusinessSearchValue) => {
        if (r && r.type === 'search-result') { // NOTE: only when business is search through ASIC/ABN endpoint
          if (r.entityTypeValue) {
            this.formControlStep3OrganisationType.setValue(r.entityTypeValue);
          }
        }
      })
    ).subscribe());

    const sub = this.formControlStep1Business.valueChanges.pipe(
      tap((r: BusinessSearchValue) => {
        if (r) {
          if (r.abn && this.formControlStep3Abn) {
            this.formControlStep3Abn.setValue(r.abn);
          }
          if (r.acn && this.formControlStep3Acn) {
            const acn = patchAcn(r.acn);
            this.formControlStep3Acn.setValue(acn ?? null);
          }

          this.organisationName = toInteflowLegalName(r) ?? '';
        }
      })
    ).subscribe();
    this.subscriptions.push(sub);

    // previousBusiness stays optional: a GST age below the product threshold is a policy exception
    // the user confirms on Next, not a blocking validation error.
    const sub2 = this.formControlStep1Business.valueChanges.subscribe(v => {
      if (v && v.type === 'search-result') { // NOTE: only deduce previousBusiness when business search is done through ASIC/ABN search
          const GSTAge = searchResultToGstAgeMonths(v.result, 0);
          if (GSTAge >= 12) {
              this.formControlStep1PreviousBusiness.setValue(null);
          }
      } else if (!this.formControlStep1PreviousBusiness.value) {
          this.formControlStep1PreviousBusiness.setValue(null);
      }
      this.formControlStep1PreviousBusiness.updateValueAndValidity({ emitEvent: false });
    })
    this.subscriptions.push(sub2);

    const sub3 = this.formControlStep1PreviousBusiness.valueChanges.pipe(
      filter(v => v != null && !v.abrResult && !!v.abn),
      switchMap(v => this.applicationService.getAbrResultByAbn(v!.abn!).pipe(
        map(abrResult => ({ v, abrResult }))
      ))
    ).subscribe(({ v, abrResult }) => {
      if (abrResult && v) {
        this.formControlStep1PreviousBusiness.setValue({ ...v, abrResult }, { emitEvent: false });
      }
    });
    this.subscriptions.push(sub3);
  }

  private async confirmGstAgeException(): Promise<boolean> {
    const result = await this.applicationDialogService
      .openAbnGstAgeExceptionDialog()
      .afterClosed()
      .toPromise();
    return !!result?.readyForSubmission;
  }

  initStep2() {
    this.formControlStep2LoanPurpose = this.formBuilder.control<LoanPurposeValue | null>(null, [Validators.required]);
    this.formControlStep2LoanAmount = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep2LoanTerms = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep2Brokerage = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep2PaymentFrequency = this.formBuilder.control({type: 'Weekly', name: 'Weekly'}, [Validators.required]);
    this.formControlStep2PropertyOwner = this.formBuilder.control(true, [Validators.required]);
    this.formControlStep2AdverseOnFile = this.formBuilder.control(false, [Validators.required]);
    this.formControlStep2EquifaxDirectorScoreAbove700 = this.formBuilder.control(true, [Validators.required]);
    this.formControlStep2DocFeeFinanced = this.formBuilder.control(true, [Validators.required]);
    this.formGroupStep2 = this.formBuilder.group({
      loanPurpose: this.formControlStep2LoanPurpose,
      // broker: this.formControlStep2Broker,
      loanTerms: this.formControlStep2LoanTerms,
      loanAmount: this.formControlStep2LoanAmount,
      brokerage: this.formControlStep2Brokerage,
      paymentFrequency: this.formControlStep2PaymentFrequency,
      propertyOwner: this.formControlStep2PropertyOwner,
      adverseOnFile: this.formControlStep2AdverseOnFile,
      equifaxScore: this.formControlStep2EquifaxDirectorScoreAbove700,
      docFeeFinanced: this.formControlStep2DocFeeFinanced,
    });

    setStepper2StepConfig(this.formGroupStep2, {
      nextStepClickedFn: async stepper => {
        // Add loan purpose validation check              
        // Mark all fields as touched to trigger validation
        this.loanPurposeComponent?.mark();
        
        // Check if the loan purpose component is invalid
        if (this.loanPurposeComponent?.formGroup?.invalid) {
          this.applicationDialogService.openAlertDialog({
            message: `Validation Error`,
            subMessage: 'Please complete all required loan purpose fields'
          });
          return;
        }

        // Keep existing validation logic
        const adverseOnFile = this.formControlStep2AdverseOnFile.value
        if (adverseOnFile) {
          this.applicationDialogService.openAlertDialog({
            message: "Warning",
            subMessage: `Approvals for business finance can only be obtained for borrowers without
            prior adverse credit.
            The borrower may still be eligible for a term loan or invoice finance.
            <br/><br/>
            Please contact your sales representative or call us on 1300 001 420.`
          })
        } else {
          if (!await this.confirmPropertySecurityIfRequired()) {
            return;
          }
          await this.step2ShowQuotation(stepper);
        }
      },
      nextStepButtonText: `Calculate Repayments`,
    });

    this.subscriptions.push(this.formControlStep2PropertyOwner.valueChanges.pipe(
      tap(r => {
        this.step2UpdateMaxLimit();
      })
    ).subscribe())

    // update max limit (GST age via business selection also affects the limit)
    this.subscriptions.push(this.formControlStep1Business.valueChanges.pipe(
      tap(r => {
        this.step2UpdateMaxLimit();
      })
    ).subscribe())
  }

  private step2UpdateMaxLimit() {
    const b: BusinessSearchValue = this.formControlStep1Business.value;
    const GSTAge = (b as BusinessSearchResultValue)?.result?.GSTAgeMonths ?? 0;
    this.step2MaxLimit = maxLoanForBusinessLoan(GSTAge, this.formControlStep2PropertyOwner.value);
  }

  initStep3() {
    this.formControlStep3OrganisationType = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep3Abn = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep3Acn = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep3AnnualRevenue = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep3PrimaryIndustry = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep3IndustrySector = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep3SubdivisionIndustrySector = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep3PrimaryBusinessAddress = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep3RegisteredBusinessAddress = this.formBuilder.control(null, [Validators.required]);
    this.formGroupStep3 = this.formBuilder.group({
      organisationType: this.formControlStep3OrganisationType,
      abn: this.formControlStep3Abn,
      acn: this.formControlStep3Acn,
      annualRevenue: this.formControlStep3AnnualRevenue,
      primaryIndustry: this.formControlStep3PrimaryIndustry,
      industrySector: this.formControlStep3IndustrySector,
      subdivisionIndustrySector: this.formControlStep3SubdivisionIndustrySector,
      primaryBusinessAddress: this.formControlStep3PrimaryBusinessAddress,
      registeredBusinessAddress: this.formControlStep3RegisteredBusinessAddress,
    });
    // Identify the applicant, so they come from step 1's verified business search and are not
    // re-typed here: changing them would invalidate the company check this step waits on.
    this.formControlStep3Abn.disable();
    this.formControlStep3Acn.disable();
    this.step3KybResultFn = this.applicationService.kybResultFn;
    this.step3KybRefreshFn = this.applicationService.kybRefreshFn;
    this.kybSetManualModeFn = this.applicationService.kybSetManualModeFn;
    const subscription =  this.formControlStep3OrganisationType.valueChanges.pipe(
      tap((r: EntityTypeValue) => { // org type changed, clear applicant field
        if (r) {
          if (this.formControlStep4Applicant) {
          }
          if(this.step3OnwardsOrganisationType && this.step3OnwardsOrganisationType !== r.type) {
            // the org type changes and is different from prev value
            this.formControlStep4Applicant.setValue(null)
          }
          this.step3OnwardsOrganisationType = r.type;
          if (r.type === 'company') {
            /* Not required to set it again as validation is already set */
          } else {
            this.formControlStep3Acn.setValidators(null);
            this.formControlStep3Acn.updateValueAndValidity();
          }
        }
      })
    ).subscribe();
    this.subscriptions.push(subscription);

    this.subscriptions.push(this.formControlStep3PrimaryIndustry.valueChanges.pipe(
      tap(r => {
          this.step3PrimaryIndustryDivisionCode = r?.code ?? null;
          this.formControlStep3IndustrySector.setValue(null);
          this.formControlStep3SubdivisionIndustrySector.setValue(null);
      })
    ).subscribe());

    this.subscriptions.push(this.formControlStep3IndustrySector.valueChanges.pipe(  
      tap(r => {
          this.step3IndustrySectorGroupCode = r?.code ?? null;
          this.formControlStep3SubdivisionIndustrySector.setValue(null);
      })
    ).subscribe());

    setStepper2StepConfig(this.formGroupStep3, {
      stepSelectionEventFn: () => {
        this.step3Active = true;
      },
      // The form is not on screen until the company check lands, so there is nothing to advance to.
      nextStepButtonDisabledFn: () => this.step3AwaitingKyb,
      nextStepClickedFn: async stepper => {
        await this.saveApplication(stepper, 3);
    }
  });

  }

  /**
   * The applicant's company check finished. Prefill both addresses from the registry into their
   * matching fields, leaving anything the broker already saved on a previous visit alone, and keep
   * the result for step 4.
   */
  onStep3KybResolved(result: KybResult) {
    this.step3KybResult = result;
    const primaryEntity = result.entities.find(entity => entity.isPrimary);
    this.step3ManualKyb = primaryEntity?.mode === 'MANUAL';
    const addresses = primaryEntity?.addresses ?? null;
    // Tested on the address line rather than the object: a saved entity with an empty address still
    // hydrates into a fully-shaped value, which reads as answered while showing the broker nothing.
    if (addresses?.registeredOffice && !this.formControlStep3RegisteredBusinessAddress.value?.address) {
      this.formControlStep3RegisteredBusinessAddress.setValue(addresses.registeredOffice);
    }
    if (addresses?.principalPlaceOfBusiness && !this.formControlStep3PrimaryBusinessAddress.value?.address) {
      this.formControlStep3PrimaryBusinessAddress.setValue(addresses.principalPlaceOfBusiness);
    }
  }

  onStep3ManualKyb(): void {
    if (this.applicationId == null) return;
    this.kybSetManualModeFn(this.applicationId).subscribe({
      next: result => this.onStep3KybResolved(result),
      error: () => undefined,
    });
  }

  initStep4() {
    // Step 4 is now the Key People (KYB) summary screen; the legacy applicant control is retained
    // (null, unvalidated) so the existing null-safe save path keeps compiling. Detailed individual
    // capture is a separate follow-up ticket.
    this.step4BusinessSearchFn = this.applicationService.businessSearchFn;
    this.step4BusinessNumberSearchFn = this.applicationService.businessNumberSearchFn;
    this.step4KybResultFn = this.applicationService.kybResultFn;
    this.step4KybInitiateCorporatePartyFn = this.applicationService.kybInitiateCorporatePartyFn;
    this.formControlStep4Applicant = this.formBuilder.control(null);
    this.formControlStep4KybKeyPeople = this.formBuilder.control(null, [Validators.required]);
    this.formGroupStep4 = this.formBuilder.group({
      applicant: this.formControlStep4Applicant,
      kybKeyPeople: this.formControlStep4KybKeyPeople,
    });

    setStepper2StepConfig(this.formGroupStep4, {
      stepSelectionEventFn: () => {
        this.step4Active = true;
      },
      nextStepValidationMessage: KYB_KEY_PEOPLE_STEP_VALIDATION_MESSAGE,
      nextStepClickedFn: async stepper => {
          if (!await this.confirmStep4KybWarnings()) {
            return;
          }
          await this.saveApplication(stepper, 4);
        }
    });
  }

  private async confirmPropertySecurityIfRequired(): Promise<boolean> {
    const loanAmount = this.formControlStep2LoanAmount.value ?? 0;
    if (loanAmount <= PROPERTY_SECURITY_ACKNOWLEDGEMENT_THRESHOLD) {
      return true;
    }
    const result = await this.applicationDialogService
      .openPropertySecurityAcknowledgementDialog()
      .afterClosed()
      .toPromise();
    return !!result?.readyForSubmission;
  }

  // KYB warnings are advisory, so they are raised here (on Next) rather than inline on the step;
  // continuing is allowed once the user confirms.
  private async confirmStep4KybWarnings(): Promise<boolean> {
    if (!this.step4KybWarnings.length) {
      return true;
    }
    const result = await this.applicationDialogService
      .openKybWarningsConfirmationDialog(this.step4KybWarnings)
      .afterClosed()
      .toPromise();
    return !!result?.readyForSubmission;
  }

  initStep5() {
    this.step5CompanySearchFn = this.applicationService.businessSearchFn;
    this.step5BusinessNumberSearchFn = this.applicationService.businessNumberSearchFn;
    this.formControlStep5Guarantors = this.formBuilder.control(null, [requiredAllowEmptyValidator]);
    this.formGroupStep5 = this.formBuilder.group({
      guarantors: this.formControlStep5Guarantors,
    });
    // No "at least one guarantor" rule: the required guarantors are captured on Key People, and
    // this step only collects the additional ones the company check did not return.

    setStepper2StepConfig(this.formGroupStep5, {
      nextStepClickedFn: async stepper => {
          await this.saveApplication(stepper, 5);
      }
    });
  }

  // individual details review, including the primary contact selection
  initStep6() {
    this.formControlStep6IndividualDetails = this.formBuilder.control(null);
    this.formGroupStep6 = this.formBuilder.group({
      individualDetails: this.formControlStep6IndividualDetails,
    });
    setStepper2StepConfig(this.formGroupStep6, {
      stepSelectionEventFn: e => {
        // re-read from the DB every time the step is entered - the KYB key people and guarantor
        // steps may have added or changed individuals in between. Wait on the previous step's
        // draft save first, otherwise this read races the write that creates those rows and a
        // guarantor added on the step before wouldn't show up until the step is re-entered.
        this.individualDetailsListComponent?.reload(this.pendingDraftSave);
      },
      previousStepClickedFn: async stepper => {
        // flush pending edits so navigating back doesn't lose them
        await this.individualDetailsListComponent?.flushChanges();
        stepper.previous();
      },
      nextStepClickedFn: async stepper => {
        // persists through /save-application-parties; deliberately NOT updateDraftInBg - the
        // legacy Individuals payload rebuilt from earlier step values would overwrite the edits
        // that were just saved on this step. mapToInteflowData re-applies them on later saves.
        const flushed = await this.individualDetailsListComponent?.flushChanges() ?? true;
        if (flushed) {
          stepper.next();
        }
      },
    });
  }

  initStep7() {
    this.step1BusinessSearchFn = this.applicationService.businessSearchFn;
    this.formControlStep7BrokerflowDocumentId = this.formBuilder.control(null);
    this.formControlStep7References = this.formBuilder.control([], [requiredAllowEmptyValidator]);
    this.formGroupStep7 = this.formBuilder.group({
      brokerflowDocumentId: this.formControlStep7BrokerflowDocumentId,
      references: this.formControlStep7References,
    });

    setStepper2StepConfig(this.formGroupStep7, {
      nextStepClickedFn: async stepper => {
        await this.saveApplication(stepper, 7);
      }
    });
  }

  // trust deeds
  initStep8() {
    this.formControlStep8TrustDeeds = this.formBuilder.control(null);
    this.formGroupStep8 = this.formBuilder.group({
      trustDeeds: this.formControlStep8TrustDeeds,
    });
    setStepper2StepConfig(this.formGroupStep8, {
      nextStepButtonText: 'Next',
      // Uploading is optional, so the step never blocks Next; a deed not supplied here stays a
      // required document on the Documents tab after submission.
      nextStepClickedFn: async stepper => {
        await this.saveApplication(stepper, 8);
      },
    });
  }

  /**
   * Re-derive which entities need a deed. Called as the parties settle, since a trust added at the
   * guarantor step changes the answer.
   */
  refreshRequiredTrustDeeds() {
    if (!this.applicationId) {
      return;
    }
    this.subscriptions.push(
      this.applicationService.requiredTrustDeedsFn(this.applicationId).subscribe({
        next: deeds => this.requiredTrustDeeds = deeds,
        // Leaves the step hidden; the deeds are still collected as conditions after submission.
        error: () => this.requiredTrustDeeds = [],
      }),
    );
  }

  onStep8DeleteUploadedDoc(deletedFile: AzureStorageDocument) {
    this.step8DeletedUploadedDocs = [...this.step8DeletedUploadedDocs, deletedFile];
    this.step9UploadedDocs = this.step9UploadedDocs.filter(doc => doc.name !== deletedFile.name);
  }

  initStep9() {
    this.formControlStep9OtherSupportingDocuments = this.formBuilder.control(null,[duplicateFileNameValidator()]);
    this.formGroupStep9 = this.formBuilder.group({
      otherSupportingDocuments: this.formControlStep9OtherSupportingDocuments,
    });

    setStepper2StepConfig(this.formGroupStep9, {
      nextStepButtonText: "Next",
      stepSelectionEventFn: e => {
        this.documentTypes = this.applicationDefaultDocuments(true);
      },
      nextStepClickedFn: async stepper => {
        const isMissingTagsCheck = this.formGroupStep9.value.otherSupportingDocuments?.filter(file => file.tags && file.tags.length === 0) ;
        console.log("isMissingTagsCheck======",isMissingTagsCheck)
        if(isMissingTagsCheck?.length){
          const fileNames = isMissingTagsCheck.map(file => file.name).join(', ');
          console.log("fileNames",fileNames)
          this.applicationDialogService.openAlertDialog({
            message: `Validation Error`,
            subMessage: `The following files are missing tags: ${fileNames}`
          });

        }else {
          await this.saveApplication(stepper, 9);
        }
      }
    });
  }

  initStep10() {
    this.formControlStep10ApplicationNotes = this.formBuilder.control(null, [Validators.required, noSpaceValidator()]);
    this.formGroupStep10 = this.formBuilder.group({
      applicationNotes: this.formControlStep10ApplicationNotes,
    });

    setStepper2StepConfig(this.formGroupStep10, {
      nextStepButtonText:'Next to Review',
      nextStepClickedFn: async stepper => {
        await this.saveApplication(stepper, 10);
      }
    });

  }

  initStep11() {
    this.formGroupStep11 = this.formBuilder.group({});
    setStepper2StepConfig(this.formGroupStep11, {
      stepSelectionEventFn: e => {


          this.step11Summary = {

            broker: this.formControlStep1Broker.value,
            loanAmount: this.formControlStep2LoanAmount.value!,
            loanPurpose: this.formControlStep2LoanPurpose.value ?? null,
            references: this.formControlStep7References.value,

            repayment: this.step2Repayment,
            estimatedDrawDownDate: this.step2EstimatedDrawdownDate,
            applicationId: String(this.applicationId),
            organisation: this.formControlStep1Business.value,

            addtionalBrokerCorrespondent: this.formControlStep1Correspondent.value,
            organisationType: this.formControlStep3OrganisationType.value,
            abn: this.formControlStep3Abn.value!,
            acn: this.formControlStep3Acn.value!,
            annualRevenue: this.formControlStep3AnnualRevenue.value!,
            primaryIndustry: this.formControlStep3PrimaryIndustry.value,
            industrySector: this.formControlStep3IndustrySector.value,
            subdivisionIndustrySector:  this.formControlStep3SubdivisionIndustrySector.value,
            primaryBusinessAddress: this.formControlStep3PrimaryBusinessAddress.value,
            registeredBusinessAddress: this.formControlStep3RegisteredBusinessAddress.value,

            loanTerms: this.formControlStep2LoanTerms.value!,
            equifaxScoreAboveThreshold: this.formControlStep2EquifaxDirectorScoreAbove700.value,
            adverseOnFile: this.formControlStep2AdverseOnFile.value,
            propertyOwner: this.formControlStep2PropertyOwner.value,
            brokerage: this.formControlStep2Brokerage.value,
            paymentFrequency: this.formControlStep2PaymentFrequency.value,
            applicants: this.formControlStep4Applicant.value ?? [],

            guarantors: this.formControlStep5Guarantors.value,
            primaryContact: savedIndividualsToPrimaryContact(this.formControlStep6IndividualDetails.value?.individuals)!,
            contacts: savedIndividualsToContacts(this.formControlStep6IndividualDetails.value?.individuals),
            applicationNotes: this.formControlStep10ApplicationNotes.value!,
            directorScore: false, // 500-550 director score question removed; field kept for payload compatibility
            brokerContact:this.formControlStep1BrokerContact.value!,
            docFeeFinanced: this.formControlStep2DocFeeFinanced.value,
          };
      },
      nextStepButtonText:'Submit',
      nextStepClickedFn: async stepper => {
        this.finalSubmission(stepper, this.step11Summary!);
      }
    });
  }


  step5GuarantorEvent($event: GuarantorComponentEvent) {
    /// $event.entries
  }

  async finalSubmission(stepper: CdkStepper, summary: BusinessFinanceSummary) {
    await this.agreeToTermsOfSubmission(stepper);
  }



  async agreeToTermsOfSubmission(stepper: CdkStepper) {
    this.subscriptions.push(consentAcknowledgementIndividuals(
      this.digitalIdService.getApplicationIndividualsFn,
      this.applicationId,
      this.formControlStep6IndividualDetails.value?.individuals,
    ).pipe(
        this.toastService.topMenuLoadingObservable(),
        switchMap(individuals => this.applicationDialogService
          .openBusinessFinanceApplicationConfirmationDialog(individuals).afterClosed()),
        tap(async (r) => {
          if (r && r.readyForSubmission) {
            this.businessUseOnly = true;
            this.selfServiceability = true;
            await this.sendFinalSubmission(stepper);
          }
      })
    ).subscribe());
  }


  async sendFinalSubmission(stepper: CdkStepper) {
    if (this.applicationId) {
      const data = await this.mapToInteflowData(true);
      console.log('submited inteflow data', data);

      // update driver licence doc metadata - as the individualId will be changed
      if (this.applicationId) {
        this.subscriptions.push(
          this.applicationService.listApplicationDocumentFn(this.applicationId).subscribe(
            (r: AzureStorageDocument[]) => {
              const driverLicenceDocs = r.filter(obj => Object.values(obj?.tags ?? {}).includes('driverslicence'));
              for (const doc of driverLicenceDocs) {
                const individual = (data.parties?.individuals ?? []).find(obj => (doc.metadata?.driverslicencename ?? '') == `${obj.givenName ?? ''} ${obj.surname ?? ''}`);
                if (individual && individual.guid) {
                  this.applicationService.updateDocumentMetadataFn(doc.name, "", {
                    ...doc.metadata,
                    individualid: individual.guid ?? ''
                  }).subscribe()
                }
              }
            }
          )
        )
      }

    this.subscriptions.push(this.applicationService.submitApplication(this.applicationId, data).pipe(
      this.toastService.spinnerObservable(),
      tap(r => {
        if (r && r.status) {
          this.applicationDialogService.openApplicationSubmittedDialog().afterClosed().pipe(
            tap(async r => {
              await this.router.navigateByUrl(navigationUrlForApplicationsWithQueryParams(this.router, {reload: true}));
            })
          ).subscribe();
        } else {
          // Handle error response with status 400
          const errorMessage = r?.message || 'Error submitting application';
          this.applicationDialogService.openAlertDialog({
            message: `Error`,
            subMessage: errorMessage
          });
        }
      }),
      catchError(error => {
        // Handle HTTP error response (like 400 Bad Request)
        const errorMessage = error?.error?.message || error?.message || 'Error submitting application';
        this.applicationDialogService.openAlertDialog({
          message: `Error`,
          subMessage: errorMessage
        });
        return of(null);
      })
    ).subscribe({}));
  }    
  }

  calculateEstimation(date: Moment): TotalPaymentBreakupDialogData {
    const paymentFrequencyValue: PaymentFrequencyValue = this.formControlStep2PaymentFrequency.value;
    const paymentFrequencyType: PaymentFrequencyType = paymentFrequencyValue?.type ?? 'Monthly';
    const loanTermValue: LoanTermsSelectionWithInputValue = this.formControlStep2LoanTerms.value;
    const loanTermType: LoanTermType | null = loanTermValue ? String(loanTermValue) as LoanTermType : null;
    const brokerageValue: BrokerageSelectionValue = this.formControlStep2Brokerage.value;
    const brokerageType: BrokerageSelectionType = brokerageValue?.type ?? '0';
    const brokerage = Number(brokerageValue?.type ?? 0);
    const loanAmount = numeral(this.formControlStep2LoanAmount.value).value() ?? 0;
    const businessSearchValue: BusinessSearchValue = this.formControlStep1Business.value;
    const businessSearchValueWithSearchResult = businessSearchValue?.type == 'search-result' ? businessSearchValue : null;
    const bureauReport = (businessSearchValue?.type === 'search-result' && businessSearchValue?.result) ? businessSearchValue.result : this.existingApplicationBureauReport;
    const equifaxDirectorScoreAbove700 = this.formControlStep2EquifaxDirectorScoreAbove700.value ?? false;
    const adverseOnFile = this.formControlStep2AdverseOnFile.value ?? false;
    const propertyOwner = this.formControlStep2PropertyOwner.value ?? false;
    const gstAgeMonths = businessSearchValueWithSearchResult?.result?.GSTAgeMonths
      ?? (this.existingApplication ? applicationToGstAgeMonths(this.existingApplication) : 0);
    const gstAgeMonthsWithContinuity = businessSearchValueWithSearchResult?.result
      ? searchResultToGstAgeMonthsWithContinuity(businessSearchValueWithSearchResult.result, this.formControlStep1PreviousBusiness.value, gstAgeMonths)
      : (this.existingApplication ? applicationToGstAgeMonthsWithContinuity(this.existingApplication) : gstAgeMonths);
    const docFeeFinanced = this.formControlStep2DocFeeFinanced.value ?? false;

    // Compute abnAgeAboveThresholdOverride based on Previous Business GST age (aligned with credit flow)
    const abnAgeAboveThresholdOverride = calculateAbnAgeOverrideFromPreviousBusiness(
      businessSearchValueWithSearchResult?.result?.ABNAgeMonths ?? 0,
      businessSearchValueWithSearchResult?.result?.GSTAgeMonths,
      this.formControlStep1PreviousBusiness.value
    );

    const r = calculateBusinessLoanEstimation(date, {
      type: 'BusinessLoans',
      paymentFrequencyType,
      loanTermType,
      brokerageType,
      loanAmount,
      businessSearchValue: businessSearchValueWithSearchResult,
      propertyOwner,
      brokerage,
      adverseOnFile,
      equifaxDirectorScoreAbove700,
      gstAgeMonths,
      gstAgeMonthsWithContinuity,
      rateCard: this.rateCard,
      bureauReport,
      docFeeFinanced,
      abnAgeAboveThresholdOverride,
    });
    this.terms = r.terms;
    this.calculator = r.calculator;
    this.step2Repayment = String(r.repayment);
    return r.totalPaymentBreakupDialogData;
  }

  private step5OnwardsApplicantsThatAreGuarantor(): IndividualGuarantor[] {
    const applicant: TrusteeValue | MemberValue | PartnerValue | SoleTraderValue | DirectorValue = this.formControlStep4Applicant.value;
    const guarantors = applicantsThatAreGuarantor(applicant);
    return guarantors;
  }

  private async step2ShowQuotation(stepper: CdkStepper) {
    // todo: workout monthly repayment and estimated darwdown date, populate chart data
    // calculate and populate
    this.step2Repayment = '12000';
    this.step2EstimatedDrawdownDate = moment().add(1, 'day');

    const subscription = this.applicationDialogService.openBusinessQuotationDialog({
      loadFn: (date) => {
        return this.calculateEstimation(date);
      },
      isQuote: false,
      paymentChartHideBalloonPayment: false,
      paymentChartHideBrokerOriginationFee: true,
      paymentChartHideBrokerage: false,
      showPaymentChart: true,
      showArmotizationChart: true,
      showRepaymentEstimation: true,
      showArmotisationSchedule: true,
    }).afterClosed()
      .pipe(
        tap(r => {
          if (r && r.acceptedQuotation) {
            this.acceptedQuotation = true;
            this.saveApplication(stepper, 2);
          }
        })
      ).subscribe();
    this.subscriptions.push(subscription);
  }


  private async saveApplication(stepper: CdkStepper, step: number) {
    if (!this.applicationId) { // application was not saved before (new draft)
      const inteflowData = await this.mapToInteflowData();
      console.log('save application (business-finance) (new)', this.applicationId, inteflowData);
      this.applicationService.saveApplication(inteflowData).pipe(
        this.toastService.spinnerObservable(),
        tap(r => {
          const applicationId = r.payload.ApplicationId;
          const brokerApplicationId = r.payload.BrokerApplicationId;
          this.brokerApplicationId = brokerApplicationId;
          this.applicationId = applicationId;
          this.syncUrlWithApplicationId();
          const business: BusinessSearchValue = this.formControlStep1Business.value
          if (business) {
            this.organisationName = business.organisationName;
          }
          this.localApplicationDbService.addOrUpdateApplicationLocally(toDraftSimplifiedApplication(this.applicationId, inteflowData));
          stepper.next();
        }),
        catchError(err => {
          this.applicationDialogService.openAlertDialog({
            message: 'Error',
            subMessage: err?.error?.message ?? 'Unable to save application. Please try again.',
          });
          return of(null);
        })
      ).subscribe();
    } else {  // existing draft
      try {
        await this.updateDraftInBg(step);
        stepper.next();
      } catch (err: any) {
        this.applicationDialogService.openAlertDialog({
          message: 'Error',
          subMessage: err?.error?.message ?? 'Unable to save application. Please try again.',
        });
      }
    }
  }

  // Put the new draft's id in the address bar so a refresh reopens it instead of starting a blank
  // application. replaceState rather than router.navigate: 'business-term-loan' and
  // 'business-term-loan/:applicationId' are separate route configs, so navigating would rebuild this
  // component and discard everything the user has entered.
  private syncUrlWithApplicationId() {
    if (!this.applicationId) {
      return;
    }
    const urlTree = navigationUrlForBusinessFinanceWithQueryParams(this.router, this.applicationId, this.queryParams);
    this.location.replaceState(this.router.serializeUrl(urlTree));
  }

  async uploadFileToAzure(step: number, data: WizardSubmitData) {
    let base64Files: Base64File[] = [];
    let allToBeDeleted: string[] = [];
    let allFiles: File[] = [];
    if (step === 4) {
      allFiles = tagIndividualIdDocumentFiles(
        this.kybKeyPeopleComponent?.manualIdDocumentUploads() ?? [],
        data.parties?.individuals ?? [],
        this.step9OtherDocMetadata,
      );
      allToBeDeleted = this.step4DeletedIdDocuments.map(document => document.name);
    } else if (step === 5) { // guarantor ID documents (driver licence / passport) from the individual form
      const uploads = [
        ...collectIndividualIdDocumentUploads(individualGarantors(this.formControlStep5Guarantors.value)),
        ...(this.guarantorComponent?.manualIdDocumentUploads() ?? []),
      ];
      allFiles = tagIndividualIdDocumentFiles(uploads, data.parties?.individuals ?? [], this.step9OtherDocMetadata);
      allToBeDeleted = this.step5DeletedIdDocuments.map(document => document.name);
    } else if (step === 8) { // trust deeds, already tagged with the condition they were dropped into
      const trustDeeds = this.formControlStep8TrustDeeds.value;
      allToBeDeleted = [...this.step8DeletedUploadedDocs].map(file => file.name);
      if (trustDeeds && trustDeeds.length) {
        allFiles = [...trustDeeds];
      }
    } else if (step === 9) { // other supporting doc
      const otherSupportingDocs: UploadFileValue = this.formControlStep9OtherSupportingDocuments.value;
      allToBeDeleted = [...this.step9DeletedUploadedDocs].map(file => file.name);
      if (otherSupportingDocs && otherSupportingDocs.length) {
        allFiles = [...otherSupportingDocs];
      }
    } else {
      return;
    }
    base64Files = [...await filesToBase64Files(allFiles)];
    // double check if any changes with existing files
    // remove file that has been uploaded
    base64Files = base64Files.map(file => {
      file.metadata = file.tags?.includes('driverslicence') ? file.metadata : this.step9OtherDocMetadata;
      return file;
    }).filter(f => {
      const fileIdentifiers = this.filesUploadedToAzure.map(m =>
        `${m.name}${m.tags?.join(' ')}${m.metadata?.individualid ?? m.metadata?.driverslicencename ?? ''}`);
      return !fileIdentifiers.includes(
        `${f.name}${f.tags?.join(' ')}${f.metadata?.individualid ?? f.metadata?.driverslicencename ?? ''}`,
      );
    })
    if (!base64Files.length && !allToBeDeleted.length) {
      return;
    }

    if (this.applicationId) {
      await lastValueFrom(
        this.applicationService.uploadApplicationDocumentToAzureStorage(
          this.applicationId,
          [...base64Files],
          allToBeDeleted,
        ),
      );
      this.filesUploadedToAzure = [...this.filesUploadedToAzure, ...base64Files];
      if(step === 4 || step === 5){
        this.listUploadedDocuments()
        if (step === 4) {
          this.step4DeletedIdDocuments = [];
        } else {
          this.step5DeletedIdDocuments = [];
        }
      }else if(step === 8){
        this.listUploadedDocuments()
        this.step8DeletedUploadedDocs = []
        this.formControlStep8TrustDeeds.setValue(null)
      }else if(step === 9){
        this.uploadFilesMultiTagsComponent.files = []
        this.uploadFilesMultiTagsComponent.filesWithTags = []
        this.uploadFilesMultiTagsComponent.formControl.setValue(null)
        this.listUploadedDocuments()
        this.formControlStep9OtherSupportingDocuments.setValue(null)
      }
    }
  }

  async mapToInteflowData(finalSubmission = false, shouldUploadDocs = false) {

    const user  = getUser();
    const b: BusinessSearchValue = this.formControlStep1Business.value;
    const correspondentDetails = this.formControlStep1Correspondent.value;
    const o: EntityTypeValue = this.formControlStep3OrganisationType.value;
    const applicationNotes = this.formControlStep10ApplicationNotes.value;
    const brokerflowDocumentId = this.formControlStep7BrokerflowDocumentId.value;
    // primary contact is selected on the individual details step and flagged on the saved rows
    const savedIndividualDetails = this.formControlStep6IndividualDetails.value;
    const contact: SelectContactValue = savedIndividualsToPrimaryContact(savedIndividualDetails?.individuals);
    const broker: AggregatorSearchComponentValue = this.formControlStep1Broker.value;
    const abn = this.formControlStep3Abn.value;
    const acn = this.formControlStep3Acn.value;
    const applicants: ApplicationApplicant = this.formControlStep4Applicant.value;
    const guarantors: GuarantorValue = this.formControlStep5Guarantors.value;
    const refValue: ReferenceValue = this.formControlStep7References.value;
    let previousBusiness: BusinessNumberSearchValue = this.formControlStep1PreviousBusiness.value;

    // workout broker salesforce id
    let brokerSalesforceId = broker!.salesforceId;
    let brokerAbn = broker!.abn;
    let brokerEntityName = broker!.entityName;
    if (user!.BrokerSalesforceId === environment.GrowFinanceGroupSalesforceId) {
      if (broker && broker.salesforceId) {
        brokerSalesforceId = broker.salesforceId;
        brokerAbn = broker.abn;
        brokerEntityName = broker.entityName;
      } else if (this.brokerOfUser && this.brokerOfUser.SalesforceId) {
        brokerSalesforceId = this.brokerOfUser.SalesforceId;
        brokerAbn = this.brokerOfUser.ABN;
        brokerEntityName = this.brokerOfUser.EntityName;
      }
    } else {
      if (this.brokerOfUser && this.brokerOfUser.SalesforceId !== undefined) {
        brokerSalesforceId = this.brokerOfUser.SalesforceId;
        brokerAbn = this.brokerOfUser.ABN;
        brokerEntityName = this.brokerOfUser.EntityName;
      }
    }

    // workout disclosure
    let disclosed = true;
    let introducerGroup = 'ECLIPXCOMMERCIAL';
    if (this.brokerOfUser) {
      if (this.brokerOfUser.Relationship !== 'disclosed') {
        disclosed = false;
        introducerGroup = 'UNDISCLOSED_ECLIPXCOMMERCIAL';
      }
    }


    // work out legalName & entityTYpe
    let legalName = toInteflowLegalName(b) ?? undefined;
    let entityType = o ? toInteflowEntityTypes(o.type) : undefined;


    // work out industries
    const primaryIndustry: PrimaryIndustrySelectionValue = this.formControlStep3PrimaryIndustry.value;
    const secondaryIndustry: SecondaryIndustrySelectionValue = this.formControlStep3IndustrySector.value;
    const subdivisionIndustrySector: SubdivisionIndustrySelectionValue = this.formControlStep3SubdivisionIndustrySector.value;
    const revenue = this.formControlStep3AnnualRevenue.value;
    const address: Address2ComponentValue = this.formControlStep3PrimaryBusinessAddress.value;
    const registeredAddress: Address2ComponentValue = this.formControlStep3RegisteredBusinessAddress.value;


    // entities
    const primaryCommercialEntity: ApplicationCommercialEntityWrite = {
      legalName: legalName ?? undefined,
      entityType: entityType,
      abn: abn ?? undefined,
      // Replaces the ACN delete below: a non-company posts no ACN at all.
      acn: (entityType !== 'PTY' || _.isEmpty(acn)) ? undefined : (acn ?? undefined),
      tradingName: '',
      // Replaces Type: 'Primary'. This is the borrower, so it holds no relationship to another entity.
      isPrimary: true,
      isGuarantor: false,
      relationships: [],
      industry: {
        primaryIndustry: primaryIndustry?.code ?? undefined,
        industrySector: secondaryIndustry?.code ?? undefined,
        // Filed under subdividionClass here, and under industryClass by asset-finance - preserved
        // as-is either way, see doc §17.6.
        subdividionClass: subdivisionIndustrySector?.code ?? undefined,
      },
      revenue: revenue ? Number(revenue) : undefined,
      businessCategory: 'SME ($1m+ Revenue | $0.5m to $5m Capital)',
      principalPlaceOfBusiness: toApiAddress(address),
      registeredBusinessAddress: toApiAddress(registeredAddress),
      abnAgeMonths: (b && b.type === 'search-result' && b?.result) ?
      b.result.ABNAgeMonths :
      this.existingApplication?.CompanyDetails ? this.existingApplication.CompanyDetails.ABNAgeMonths : undefined
    }

    // commercial entities
    const otherCommercialEntities = fromApplicantToInteflowCommercialEntities(applicants);
    const guarantorCommercialEnttities = fromGuarantorToInteflowCommercialEnttities(guarantors);
    const otherCommercialEntity = [
      ...otherCommercialEntities,
      ...guarantorCommercialEnttities,
    ];

    // individuals
    const applicantIndividuals = fromApplicantToInteflowIndividualsData(applicants);
    let guarantorIndividuals = fromGuarantorToInteflowIndividuals(guarantors);

    // for trust application with only corporate trustee, the guarantors are guarantor/signer
    if (entityType === 'TRST' && !applicantIndividuals.length) {
      guarantorIndividuals =  guarantorIndividuals.map(i => {
        return {
          ...i,
          // Was SignerRole: 'GuarantorSigner'. The write shape carries the two facts the string
          // encoded, and these individuals already guarantee - so this is the signing half.
          isSigner: true,
        }
      })
    }

    const otherIndividuals = [
      ...applicantIndividuals,
      ...guarantorIndividuals,
    ];


    // reference
    const references =  fromReferenceToInteflowReferences(refValue);

    // pricing details
    // NOTE: changes done here needs to be done in business-pricing.component.ts as well
    const loanTerm: LoanTermsSelectionWithInputValue = this.formControlStep2LoanTerms.value;
    const loanAmount = _.round(this.formControlStep2LoanAmount.value ?? 0, 2);
    const brokerage: BrokerageSelectionValue = this.formControlStep2Brokerage.value;
    const paymentPeriod: PaymentFrequencyValue = this.formControlStep2PaymentFrequency.value;
    const docFee = this.terms?.docFee ?? undefined;
    const brokerOriginationFee = this.terms?.brokerOriginationFee ?? 0;
    const propertyOwner = this.formControlStep2PropertyOwner.value;
    const adverseOnFile = this.formControlStep2AdverseOnFile.value;
    const equifaxScore = this.formControlStep2EquifaxDirectorScoreAbove700.value;
    const rate = this.terms?.totalInterest ?? undefined;
    const loanPurpose: LoanPurposeValue | null = this.formControlStep2LoanPurpose.value;
    const repayment = this.calculator?.emiAmt ?? undefined;
    const docFeeFinanced = !!this.formControlStep2DocFeeFinanced.value;

    let apiBodyPricingDetails: SaveApplicationPricingDetailsData = {
      LoanTerm: loanTerm ?? undefined,
      Brokerage: brokerage ? numeral(brokerage.type).value() ?? undefined : undefined,
      BrokerOriginationFee: brokerOriginationFee,
      LoanAmount: loanAmount,
      PaymentPeriod: paymentPeriod ? paymentPeriod.name : undefined,
      DocFee: (docFee != null ? Number(docFee) : undefined),
      DocFeeFinanced: booleanToYesNo(docFeeFinanced),
      PropertyOwner: booleanToYesNo(propertyOwner),
      BankStatementSubmitted: 'No' as const,
      AdverseOnFile: booleanToYesNo(adverseOnFile),
      // ZEN-818 follow-up: BL now writes only the new threshold field; the legacy
      // boolean would mis-classify 600-699 applicants when set from a >=700 toggle.
      EquifaxDirectorScoreThreshold: equifaxScore ? '>=700' : '<700',
      DirectorScoreRate: 'No', // 500-550 director score question removed; field kept for backend compatibility
      Rate: rate,
      Repayment: repayment,
      CreditRateAdjustment: 0, // when creating an application, creditRateAdjustment is 0
      LastUpdatedByUser: null, // when creating an application, lastUpdatedByUser is null
      RepaymentType: 'Arrears'
    }

    // file tags
    const otherSupportingDocs: UploadFileValue = this.formControlStep9OtherSupportingDocuments.value;
    const idDocumentUploads = [
      ...collectIndividualIdDocumentUploads(individualGarantors(guarantors)),
      ...(this.kybKeyPeopleComponent?.manualIdDocumentUploads() ?? []),
      ...(this.guarantorComponent?.manualIdDocumentUploads() ?? []),
    ];
    const allToBeDeleted = [...this.step9DeletedUploadedDocs].map(file => file.name);
    let allFiles: File[] = tagIndividualIdDocumentFiles(idDocumentUploads, otherIndividuals, this.step9OtherDocMetadata);
    if (otherSupportingDocs && otherSupportingDocs.length) {
      allFiles = [...allFiles, ...otherSupportingDocs];
    }

    allFiles = [...allFiles].filter(file => !allToBeDeleted.includes(file?.name));

    // get doc types
    let uploadedTags = allFiles.reduce((tags: string[], file) => [...tags, ...((file as any).tags ?? [])], []);
    uploadedTags = [...uploadedTags, ...this.step9UploadedDocs.reduce((tags: string[], file: AzureStorageDocument) => [...tags, ...Object.values(file?.tags ?? {})], [])];
    uploadedTags = [...new Set(uploadedTags)];
    console.log('=====uploadedTags: ', uploadedTags);
    for (const tag of uploadedTags) {
      if (!this.documentTypes.map(t => t.value).includes(tag)) {
        const tagObj = (Object.values(constants.documentTypes) as DocumentTag[]).find(obj => obj.value === tag);
        if (tagObj) {
          this.documentTypes.push(tagObj);
        }
      }
    }
    console.log('====updated defaultTags: ', this.documentTypes);

    const companyDetails = (b && b.type === 'search-result' && b?.result) ?
      b.result :
        this.existingApplication?.CompanyDetails ? this.existingApplication.CompanyDetails : undefined;

    const apiBodyReferences = [
      ...references
    ];

    const otherIndividual  = [
      ...otherIndividuals
    ];

    const apiBodyCommercialEntities = [
      primaryCommercialEntity,
      ...otherCommercialEntity,
    ];

    const apiBodyContact = fromContactToInteflowContacts(contact);
    const contacts = contact;
    let apiBodyIndividuals =  otherIndividual.map(individual => ({
      ...individual,
      isPrimaryContact:
        individual.givenName === contacts?.firstName &&
        individual.surname === contacts?.lastName &&
        individual.email === contacts?.email,
    }));

    // The Individual Details step saves its edits straight to ApplicationIndividual, but every
    // draft save and the final submission rebuild this payload from the earlier step forms and
    // full-sync the parties - overlay the saved rows or those writes would revert them.
    if (savedIndividualDetails) {
      apiBodyIndividuals = mergeSavedIndividualsIntoInteflowIndividuals(apiBodyIndividuals, savedIndividualDetails.individuals);
    }

    const apiBodyAppInfo = {
      BrokerAppID: this.brokerApplicationId ?? undefined,
      IntroducerGroup: introducerGroup,
      Disclosed: disclosed,
      ApplicationType: 'BusinessLoans',
      FinanceType: 'Business Loan',
      LoanPurpose: loanPurpose ?? undefined,
      UserId: user!.UserId,
      OriginatorBusinessId: user!.OriginatorBusinessId,
      UserEmail: user!.Email,
      UserFirstName: user!.GivenName,
      UserLastName: user!.FamilyName,
      Notes: applicationNotes ?? undefined,
      BusinessUse: booleanToYesNo(this.businessUseOnly),
      SelfServiceability:  booleanToYesNo(this.selfServiceability),
      BrokerflowDocumentID: brokerflowDocumentId ?? undefined,
      BrokerSalesforceID: brokerSalesforceId,
      BrokerAbn: brokerAbn,
      BrokerEntityName: brokerEntityName,
      AssetCategory: '138',
      AssetType: '1',
      ContactId: undefined,
      CustomerId: undefined,
      SalesforceId: undefined,
      StageName: 'Draft',
    };


    // broker contact
    const brokerContact: SalesforceContactSameAccountSelectionValue = this.formControlStep1BrokerContact.value;

    const apiBody: WizardSubmitData = {
      ApplicationType: 'BusinessLoans',
      IP: this.ip,
      ApplicantLocation: this.geoLocation,
      UserId: this.applicationService.getApplicationUserId(this.existingApplication,this.user),
      OriginatorBusinessId: this.applicationService.getApplicationOriginatorBusinessId(this.existingApplication,this.user),
      AdditionalBrokerCorrespondent: correspondentDetails,
      BrokerContact: brokerContact,
      AppInfo: apiBodyAppInfo,
      AssetSpec: undefined,
      Contacts: apiBodyContact,
      // AZ-1475: both party arrays go over the wire in the API shape.
      parties: { individuals: apiBodyIndividuals, commercialEntities: apiBodyCommercialEntities },
      Reference: apiBodyReferences,
      PricingDetails: apiBodyPricingDetails,
      AcceptQuotation: this.acceptedQuotation,
      ApplicationNotes: applicationNotes ?? undefined,
      CompanyDetails: companyDetails ?? undefined,
      // Documents: apiBodyDocuments,
      DocumentTypes: this.documentTypes,
      PreviousBusiness: previousBusiness,
    }
    return apiBody;
  }


  // Steps that re-read parties can wait on the most recent draft save.
  private pendingDraftSave: Promise<void> = Promise.resolve();

  private async updateDraftInBg(step: number, fn?: ()=>void) {
    if (this.applicationId) {
      const data = await this.mapToInteflowData();
      // KYB "Key People" (step 4) rides on the same update-application2 request as the rest of the
      // parties so both saves share one transaction and cannot race/clobber role flags.
      if ((step === 4 || step === 5) && this.formControlStep4KybKeyPeople.value) {
        data.kybKeyPeople = mergeGuarantorKybSelections(this.formControlStep4KybKeyPeople.value, this.step5KybSelections);
      }
      this.localApplicationDbService.addOrUpdateApplicationLocally(toDraftSimplifiedApplication(this.applicationId, data));
      const save = this.applicationService.updateApplication(this.applicationId, data).pipe(
        tap(() => {
          if (fn) {
            fn();
          }
          // The entity and guarantor steps are what decide whether a deed is needed, so the trust
          // deed step's visibility is settled once their save has landed.
          if (step === 4 || step === 5 || step === 7) {
            this.refreshRequiredTrustDeeds();
          }
        })
      );
      // The Azure upload and SQL draft update are independent. Run them together, but keep one
      // loading lifecycle and require both acknowledgements before the step can advance.
      const saveOperation = from(Promise.allSettled([
        this.uploadFileToAzure(step, data),
        lastValueFrom(save),
      ])).pipe(
        fn
          ? this.toastService.loadingWithMessage(`Saving, please be patient`)
          : this.toastService.spinnerObservable(),
        map(results => {
          const failed = results.find(result => result.status === 'rejected');
          if (failed?.status === 'rejected') {
            throw failed.reason;
          }
        }),
      );
      const savePromise = lastValueFrom(saveOperation);
      this.pendingDraftSave = savePromise.then(() => undefined, () => undefined);
      await savePromise;
    }
  }

  onIdDocumentDelete(step: 4 | 5, document: UploadedDocumentRef) {
    const deleted = step === 4 ? this.step4DeletedIdDocuments : this.step5DeletedIdDocuments;
    if (!deleted.some(candidate => candidate.name === document.name)) {
      if (step === 4) {
        this.step4DeletedIdDocuments = [...deleted, document];
      } else {
        this.step5DeletedIdDocuments = [...deleted, document];
      }
    }
    this.applicationDocuments = this.applicationDocuments?.filter(candidate => candidate.name !== document.name) ?? null;
    this.step9UploadedDocs = this.step9UploadedDocs.filter(candidate => candidate.name !== document.name);
    this.filesUploadedToAzure = this.filesUploadedToAzure.filter(file => file.name !== document.metadata?.name);
  }


  onStep9DeleteUploadedDoc($event: UploadedFilesListComponentEvent) {
    this.filesUploadedToAzure = this.filesUploadedToAzure
      .filter(file => {
        return !(file.name === $event.deletedFile.metadata?.name);
      });
    this.step9DeletedUploadedDocs = [...$event.deleted];
  }

  // private step2UpdateMaxLimit() {
    // const b: BusinessSearchValue = this.formControlStep1Business.value;
    // const GSTAge = (b as BusinessSearchResultValue)?.result?.GSTAgeMonths ?? 0;
    // this.subscriptions.push(this.formControlStep2PropertyOwner.valueChanges.pipe(
    //   tap(r => {
    //     if(r){
    //       this.step2MaxLimit = maxLoanForBusinessLoan(GSTAge);
    //     }else{
    //     this.step2MaxLimit=100000;
    //   }
    //   })
    // ).subscribe());
  // }

  get step9OtherDocMetadata() {
    const b: BusinessSearchValue = this.formControlStep1Business.value;
    const abn = this.formControlStep3Abn.value ?? '';
    const legalName = toInteflowLegalName(b) ?? '';

    return {
      abn: abn,
      legalname: legalName
    };
  }

  onStep9DocEvent(files: UploadAzureFiles) {
    if(files && files.length > 0) {
      this.formControlStep9OtherSupportingDocuments.setValue(files)
    } else {
      this.formControlStep9OtherSupportingDocuments.setValue(null)
    }
  }

  applicationDefaultDocuments(includeOptions = false): DocumentTag[] {
    const applicantsThatAreGuarantor: IndividualGuarantor[] = this.step5OnwardsApplicantsThatAreGuarantor();
    const guarantors: IndividualGuarantor[] = individualGarantors(this.formControlStep5Guarantors.value);
    const names = [...applicantsThatAreGuarantor, ...guarantors]
      .map(requireDriverLicence => `${requireDriverLicence.firstName} ${requireDriverLicence.lastName}`);
    return this.defaultDocuments(
      'BusinessLoans',
      names,
      toInteflowLegalName(this.formControlStep1Business.value) ?? "",
      "",
      "",
      this.formControlStep2LoanAmount.value ?? 0,
      0,
      false,
      this.formControlStep3OrganisationType.value === EntityTypeTrustOption,
      this.formControlStep3OrganisationType.value === EntityTypePartnershipOption,
      includeOptions
    );
  }

  listUploadedDocuments() {
    if (this.applicationId) {
      this.subscriptions.push(
        this.applicationService.listApplicationDocumentFn(this.applicationId).subscribe(
          (r: AzureStorageDocument[]) => {
            // includes ID documents (driver licence / passport) uploaded through the individual form
            const documents = r.filter(arg => arg.metadata);
            this.step9UploadedDocs = documents;
            this.applicationDocuments = documents;
          }
        )
      )
    }
  }

}
